import React, { createContext, useContext, useState } from "react";

const HeroContext = createContext({
  showContent: false,
  setShowContent: () => {},
});

export const useHeroContext = () => useContext(HeroContext);

export const HeroProvider = ({ children }) => {
  const [showContent, setShowContent] = useState(false);

  return (
    <HeroContext.Provider value={{ showContent, setShowContent }}>
      {children}
    </HeroContext.Provider>
  );
};

